// src/components/Authentication.js

import { useEffect } from "react";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { useData } from "../hooks/useData";

const Authentication = () => {
  const { setUser, setError, setLoading } = useData();

  useEffect(() => {
    const auth = getAuth();
    console.log("Authentication: useData", { setUser, setError, setLoading });
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        setLoading(false);
      } else {
        setLoading(true);
        signInAnonymously(auth)
          .then((result) => {
            setUser(result.user);
          })
          .catch((error) => {
            console.warn("Anonymous auth failed:", error.message);
            setUser({ uid: "guest", isAnonymous: true });
            setError("Authentication unavailable. Using guest mode.");
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });

    return () => unsubscribe();
  }, [setUser, setError, setLoading]);

  return null;
};

export default Authentication;
